function translateFragment(isWebgl2, fShader) {
  return isWebgl2
    ? fShader
    : fShader
        .replace(/ in /g, " varying ")
        .replace(/ out /g, " varying ")
        .replace(/ out vec4 fragColor; /g, "")
        .replace(/ fragColor /g, "gl_FragColor")
        .replace(/ texture\(/g, "texture2D(");
}

export default translateFragment;
